import { IClub } from '../player/clubs/store';

export interface INotification {
  status: 'read' | 'unread';
}

export interface IAlertNotification extends INotification {
  alertType: 'message' | 'invitation';
  club: IClub;
  date: string;
  type: 'alert';
}

export interface IMessageNotification extends INotification {
  text: string;
  type: 'success' | 'error';
}

export type OpenNotificationType = 'message' | 'alert' | boolean;

export interface INotificationsStore {
  alert: IAlertNotification;
  message: IMessageNotification;
  open: OpenNotificationType;
}

export interface ILocalMessageState {
  club?: IClub;
  notification: IMessageNotification | IAlertNotification;
  open: boolean;
}

export const shallowAlertNotification = ({
  alertType: 'invitation',
  date: '',
  status: 'read',
  type: 'alert'
} as unknown) as IAlertNotification;

export const shallowMessageNotification = ({
  status: 'read',
  text: '',
  type: 'success'
} as unknown) as IMessageNotification;

export const initialLocalMessageState: ILocalMessageState = {
  notification: shallowMessageNotification,
  open: false
};

export const notificationsStore = {
  alert: shallowAlertNotification,
  message: shallowMessageNotification,
  open: false
};
